import { useCallback, useState } from 'preact/hooks';

import { ImageSlider } from 'components/ImageSlider';
import { MediaList } from 'components/MediaList';
import { Modal } from 'components/Modal';

interface ThumbnailsProps {
  items: string[];
}

export function Thumbnails({ items }: ThumbnailsProps) {
  const [slide, setSlide] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);

  const handleClick = useCallback((index: number) => {
    setSlide(index);
    setModalOpen(true);
  }, []);

  const handleModalClose = useCallback(() => {
    setModalOpen(false);
  }, []);

  return (
    <>
      <MediaList items={items} onClick={handleClick} />
      <Modal condensed large open={modalOpen} onClose={handleModalClose}>
        <ImageSlider images={items} initialSlide={slide} />
      </Modal>
    </>
  );
}
